import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import LazyImgixImage from '@components/LazyImgixImage';
import { partners_list_path } from '@routes';
import { getImgixSrc } from '@utils/images';

const BrandPartner = () => {
  return (
    <aside className="-ml-16 mb-[116px] flex w-[calc(100%_+_32px)] flex-wrap items-center justify-center gap-56 bg-grayscale-charcoal pb-56 sm:-ml-28 sm:mb-[160px] sm:w-[calc(100%_+_56px)] sm:flex-nowrap sm:justify-start sm:gap-90 sm:pb-0 md:gap-[109px] lg:gap-[160px] xl:gap-[100px] 2xl:mx-auto">
      <LazyImgixImage
        src={getImgixSrc({ path: 'about/partners.jpg', isEnvDependent: false })}
        className="static right-0 top-0 h-full w-full object-cover transition-all duration-300 sm:absolute sm:w-auto sm:max-w-none"
        alt="Brand Partnerships"
        wrapperClassName="relative w-full flex-shrink-0 overflow-hidden sm:min-h-[428px] sm:w-[340px] md:w-[445px] md:min-h-[480px] lg:w-5/12"
      />
      <div className="gap flex w-[365px] flex-col items-center justify-center p-16 sm:w-1/2">
        <div className="flex max-w-lg flex-col">
          <div className="font-suisse-works text-headline-md text-white">Brand Partnerships</div>
          <div className="mt-8 font-suisse-neue text-body-lg text-white">
            The Information works with companies to reach our subscribers with high-quality
            messages.
          </div>
          <div className="flex">
            <PrimaryButton as="link" href={partners_list_path()} className="mt-32">
              Connect with our team
            </PrimaryButton>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default BrandPartner;
